import flatpickr from "/Scripts/flatpickr.js";

// flatpickrService.js

export const flatpickrService = {
    // 當前實例
    datePicker: null,
    mobileDatePicker: null,
    dateRange: null,
    callbacks: {}, // 用 key 存各自的 callback

    // 初始化主日期選擇器
    initMainDatepicker(rootEl) {
      if (!rootEl) return;

      if (!this.datePickers) this.datePickers = []; // ✅ 加這行

      if (rootEl.dataset.pickerInited === "1") return;
      rootEl.dataset.pickerInited = "1";

      const el = rootEl.querySelector(".costom_datepicker");
      if (!el) return;

      const fp = flatpickr(el, {
        mode: "range",
        dateFormat: "Y/m/d",
        showMonths: 2,
        minDate: "today",
        inline: true,
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
          months: {
            shorthand: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            longhand: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
        },

        onClose: (dateObj) => {
          // 先照你原本：暫時還是共用 this.dateRange
          this.dateRange = dateObj;
        },
      });

      this.datePickers.push({ rootEl, el, fp });

      this.setupDateRangeButtons(rootEl);
    },

    // 初始化移動版日期選擇器
    initMobileDatepicker(rootEl) {
      this.mobileDatePicker = flatpickr("#m_datepicker", {
        dateFormat: "Y/m/d",
        mode: "range",
        //locale: "zh",
        showMonths: 1,
        inline: true,
        minDate: "today",
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
          months: {
            shorthand: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            longhand: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
        },
        onClose: (dateObj) => {
          this.dateRange = dateObj;
          const callback = this.callbacks["m"];
          if (typeof callback === "function") {
            callback(this.dateRange);
          }
        },
      });
      this.setupDateRangeButtons(rootEl);
    },

    // 設定並顯示日期選擇器
    showDatepicker(e) {
      const scope = e?.currentTarget?.closest(".leftsidebar, .searchbar");
      const rootEl = scope ? scope.querySelector(".datePicker_popup") : null;
      if (!rootEl) return;

      if (rootEl.dataset.pickerInited !== "1") {
        this.initMainDatepicker(rootEl);
      }

      this.calculateDatepickerPosition(e, rootEl);
    },

    // 設定日期範圍的通用方法
    setDateRange(startDate, endDate, rootEl) {
      // 先保留你原本的共用 state（之後要分開再改）
      this.dateRange = [startDate, endDate];

      if (!rootEl) return;

      // 找出這顆 popup 內的 input
      const el = rootEl.querySelector(".costom_datepicker");
      if (!el) return;

      // 從 registry 找到對應的 flatpickr instance
      const item = (this.datePickers || []).find((x) => x.el === el);
      const fp = item ? item.fp : null;
      if (!fp) return;

      if (startDate && endDate) {
        fp.setDate([startDate, endDate], true); // 第二參數 true：觸發更新
        this.dateRange = [startDate, endDate];
      } else {
        fp.clear();
      }
    },

    // 設置日期範圍按鈕
    setupDateRangeButtons(rootEl) {
      if (!rootEl) return;

      // 防止同一顆 popup 重複綁定
      if (rootEl.dataset.rangeBtnsBound === "1") return;
      rootEl.dataset.rangeBtnsBound = "1";

      const applyRange = (daysOrMonths, isMonths) => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const endDate = new Date(today);
        if (isMonths) {
          endDate.setMonth(today.getMonth() + daysOrMonths);
        } else {
          endDate.setDate(today.getDate() + daysOrMonths);
        }

        // 這裡先沿用你原本的流程
        this.setDateRange(tomorrow, endDate, rootEl);
      };

      // 綁 days
      rootEl.querySelectorAll(".radio[data-range-days]").forEach((radioBox) => {
        radioBox.addEventListener("click", (e) => {
          e.stopPropagation();
          const days = parseInt(radioBox.getAttribute("data-range-days"), 10);
          if (!Number.isFinite(days)) return;
          applyRange(days, false);
        });
      });

      // 綁 months
      rootEl
        .querySelectorAll(".radio[data-range-months]")
        .forEach((radioBox) => {
          radioBox.addEventListener("click", (e) => {
            e.stopPropagation();
            const months = parseInt(
              radioBox.getAttribute("data-range-months"),
              10,
            );
            if (!Number.isFinite(months)) return;
            applyRange(months, true);
          });
        });

      const setupButtonForM = (id, daysOrMonths, isMonths = false) => {
        const element = document.getElementById(id);
        if (!element) return;

        element.addEventListener("click", () => {
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);

          const endDate = new Date(today);
          if (isMonths) {
            endDate.setMonth(today.getMonth() + daysOrMonths);
          } else {
            endDate.setDate(today.getDate() + daysOrMonths);
          }

          const callback = this.callbacks["m"];
          if (typeof callback === "function") {
            callback([tomorrow, endDate]);
          }
          //this.setDateRange(tomorrow, endDate);
        });
      };
      setupButtonForM("fourteen_m", 14);
      setupButtonForM("thirtyDays_m", 30);
      setupButtonForM("twoMonths_m", 2, true);
      setupButtonForM("threeMonths_m", 3, true);
      setupButtonForM("fourMonths_m", 4, true);
      setupButtonForM("sixMonths_m", 6, true);
    },

    // 計算日期選擇器位置
    calculateDatepickerPosition(e, rootEl) {
      if (!rootEl) return;

      const root = e?.currentTarget?.closest(".leftsidebar, .searchbar");
      if (!root) return;

      const starts = Array.from(root.querySelectorAll(".input_bar_date-start"));
      if (starts.length === 0) return;

      // 1) 優先挑「目前可見」的那顆
      let btn =
        starts.find((b) => {
          const r = b.getBoundingClientRect();
          return r.bottom > 0 && r.top < window.innerHeight; // 在 viewport 內
        }) || null;

      // 2) 如果沒有可見的（例如整個區塊被隱藏/scroll 到外面），退回第一顆
      if (!btn) btn = starts[0];

      const btnRect = btn.getBoundingClientRect();

      // popup 可能剛 display=block，這裡用 offsetHeight
      const popupHeight = rootEl.offsetHeight;

      const left = btnRect.left + window.scrollX;
      let top = btnRect.bottom + window.scrollY;

      const windowBottom = window.scrollY + window.innerHeight;
      if (top + popupHeight > windowBottom) {
        top = btnRect.top + window.scrollY - popupHeight;
      }

      rootEl.style.position = "absolute";
      rootEl.style.left = left + "px";
      rootEl.style.top = top + "px";
    },

    // 調整移動版日期選擇器寬度
    adjustMobileDatepickerWidth() {
      setTimeout(() => {
        const input = document.querySelector(".date_wrap");
        const flatpickrCalendar = document.querySelector(
          ".date_wrap .flatpickr-calendar",
        );
        if (input && flatpickrCalendar) {
          flatpickrCalendar.style.width = `${input.offsetWidth}px`;
        }
      }, 0);
    },

    // 設置所有事件處理器
    setupEventHandlers(rootEl) {
      if (!rootEl) return;

      // 防止同一個 rootEl 重複綁事件
      if (rootEl.dataset.bound === "1") return;
      rootEl.dataset.bound = "1";

      const popup = rootEl; // 你的 template 最外層就是 .datePicker_popup

      const openPopup = (e) => {
        e.stopPropagation();
        popup.style.display = "block";
        this.showDatepicker(e);
      };

      const closePopup = () => {
        popup.style.display = ""; // 或 "none"，看你 CSS 預設
      };

      // 1) 只在「這個 component 所在區塊」綁 input click
      //    這裡假設 rootEl 跟 input 在同一個 .leftsidebar/.searchbar 容器內
      const scope = rootEl.closest(".leftsidebar, .searchbar") || document;
      scope
        .querySelectorAll(".input_bar_date-start, .input_bar_date-end")
        .forEach((input) => {
          input.addEventListener("click", openPopup);
        });

      // 2) reset / enter（只綁自己這顆 popup 內的按鈕）
      const resetBtn = popup.querySelector(".reset");
      resetBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        closePopup();
      });

      const enterBtn = popup.querySelector(".enter");
      enterBtn?.addEventListener("click", (e) => {
        e.stopPropagation();

        // ✅ 取本 popup 對應的 fp
        const item = (this.datePickers || []).find((x) => x.rootEl === popup);
        const selected = item?.fp?.selectedDates || [];

        // 同步一下（保留你原本的 this.dateRange 用法）
        this.dateRange = selected;

        const key = popup.dataset.cbKey || "pc";
        const callback = this.callbacks[key];
        if (typeof callback === "function") {
          callback(selected);
        }

        closePopup();
      });

      // 3) 點 popup 內部不要冒泡到 body（避免點一下就被關）
      popup.addEventListener("click", (e) => e.stopPropagation());

      // 4) 點外部關閉：用 capture + contains 判斷，只關自己這顆
      //    （避免你每顆 popup 都關掉別人的）
      const onBodyClick = (e) => {
        if (!popup.contains(e.target)) closePopup();
      };
      document.body.addEventListener("click", onBodyClick);

      // 移動版按鈕切換
      const dateBtn = document.querySelector(".m_datepicker_wrap .date_btn");
      const rangeBtn = document.querySelector(
        ".m_datepicker_wrap .selectRange_btn",
      );

      if (dateBtn && rangeBtn) {
        dateBtn.addEventListener("click", () => {
          dateBtn.classList.add("active");
          rangeBtn.classList.remove("active");
        });

        rangeBtn.addEventListener("click", () => {
          dateBtn.classList.remove("active");
          rangeBtn.classList.add("active");
        });
      }

      // 移動版篩選按鈕
      const filterBtn = document.querySelector(".filter_btn-m");
      if (filterBtn) {
        filterBtn.addEventListener("click", () =>
          this.adjustMobileDatepickerWidth(),
        );
      }

      // 移動版日期輸入框點擊
      const mobileFilterInputs = document.querySelectorAll(
        ".filter_dialog .filterSpace_input, .filter_dialog .input_bar_date-start, .filter_dialog .input_bar_date-end",
      );
      mobileFilterInputs.forEach((input) => {
        input.addEventListener("click", () => {
          this.adjustMobileDatepickerWidth();
          document.querySelector(".m_datepicker_wrap").classList.add("active");

          if (!this.datePicker) {
            this.initMainDatepicker();
          }
        });
      });

      // 移動版收合按鈕
      const collapseBtn = document.querySelector(
        ".filter_dialog .collapse_btn",
      );
      if (collapseBtn) {
        collapseBtn.addEventListener("click", () => {
          this.adjustMobileDatepickerWidth();
          document
            .querySelector(".m_datepicker_wrap")
            .classList.remove("active");
        });
      }
    },

    // 初始化所有日期選擇器功能
    init(key, callback, rootEl) {
      if (typeof callback === "function" && key) {
        this.callbacks[key] = callback;
      }

      // ✅ 你現在是多 instance 模式，rootEl 一定要有
      if (!rootEl || !rootEl.dataset) {
        console.warn("[flatpickrService.init] invalid rootEl:", rootEl);
        return;
      }

      if (rootEl.dataset.handlersInited === "1") return;
      rootEl.dataset.handlersInited = "1";
      rootEl.dataset.cbKey = key;

      this.initMobileDatepicker(rootEl);
      this.setupEventHandlers(rootEl);
    },
};

window.flatpickr = window.flatpickr || flatpickr;
window.flatpickrService = flatpickrService;

export default flatpickrService;
